import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";

import API_URL from "../../config";

const Jobs = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [jobs, setJobs] = useState([]);

    const [filteredJobs, setFilteredJobs] = useState([]);

    const [search, setSearch] = useState("");

    const [selectedJob, setSelectedJob] = useState(null);

    const [selectedApplicants, setSelectedApplicants] = useState([]);

    const [deleteId, setDeleteId] = useState(null);

    useEffect(() => {

        fetchJobs();

    }, []);

    useEffect(() => {

        filterJobs();

    }, [search, jobs]);

    const fetchJobs = async () => {

        try {

            setLoading(true);

            const token = localStorage.getItem("adminToken");

            const response = await api.get("/admin/jobs");

            setJobs(response.data.data || []);
            setFilteredJobs(response.data.data || []);

        } catch (error) {

            console.error("Error fetching jobs", error);

        } finally {

            setLoading(false);

        }

    };

    const filterJobs = () => {

        if (!search.trim()) {

            setFilteredJobs(jobs);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = jobs.filter((job) =>

            job.job_title?.toLowerCase().includes(keyword) ||

            job.company_name?.toLowerCase().includes(keyword) ||

            job.location?.toLowerCase().includes(keyword) ||

            job.job_type?.toLowerCase().includes(keyword)

        );

        setFilteredJobs(filtered);

    };

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(

                `${API_URL}/admin/jobs/${deleteId}`

            );

            fetchJobs();

        } catch (error) {

            console.error("Delete failed", error);

        }

    };

    const toggleStatus = async (job) => {

        try {

            const newStatus =
                job.status === "Active"
                    ? "Inactive"
                    : "Active";

            await api.put(

                `${API_URL}/admin/jobs/${job.id}/status`,

                {
                    status: newStatus
                }

            );

            fetchJobs();

        } catch (error) {

            console.error("Status update failed", error);

        }

    };

    const viewApplicants = async (jobId) => {

        try {

            const response = await api.get(

                `${API_URL}/admin/jobs/${jobId}/applications`

            );

            setSelectedApplicants(response.data);

        } catch (error) {

            console.error("Applicants fetch failed", error);

        }

    };

    const columns = [

        {
            key: "id",
            label: "ID"
        },

        {
            key: "job_title",
            label: "Job Title"
        },

        {
            key: "company_name",
            label: "Company"
        },

        {
            key: "location",
            label: "Location"
        },

        {
            key: "job_type",
            label: "Type"
        },

        {
            key: "status",
            label: "Status"
        }

    ];
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Jobs..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader

                title="Jobs"

                subtitle="Manage all job postings"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Jobs"
                    }
                ]}

            />

           <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search jobs..."
        />

    </div>

    <DataTable
        title="Job List"
        columns={columns}
        data={filteredJobs}
        emptyMessage="No jobs found."
        actions={(job) => (

            <div className="flex flex-wrap justify-center gap-2">

                <button
                    onClick={() => setSelectedJob(job)}
                    className="px-3 py-2 rounded-xl bg-blue-100 text-blue-600 hover:bg-blue-200"
                >
                    View
                </button>

                <button
                    onClick={() =>
                        navigate(`/admin/jobs/edit/${job.id}`)
                    }
                    className="px-3 py-2 rounded-xl bg-yellow-100 text-yellow-700 hover:bg-yellow-200"
                >
                    Edit
                </button>

                <button
                    onClick={() => setDeleteId(job.id)}
                    className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200"
                >
                    Delete
                </button>

                <button
                    onClick={() => toggleStatus(job)}
                    className={`px-3 py-2 rounded-xl text-white ${
                        job.status === "Active"
                            ? "bg-gray-600 hover:bg-gray-700"
                            : "bg-green-600 hover:bg-green-700"
                    }`}
                >
                    {job.status === "Active"
                        ? "Deactivate"
                        : "Activate"}
                </button>

                <button
                    onClick={() => viewApplicants(job.id)}
                    className="px-3 py-2 rounded-xl bg-indigo-600 text-white hover:bg-indigo-700"
                >
                    Applicants
                </button>

            </div>

        )}
    />

</div>
            <ConfirmModal
    open={deleteId !== null}
    title="Delete Job"
    message="Are you sure you want to delete this job?"
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
                    {selectedJob && (

                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)"
                    }}
                >

                    {selectedJob && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

<div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl p-8">

<div className="flex justify-between items-center mb-8">

<h2 className="text-2xl font-bold">
Job Details
</h2>

<button
onClick={() => setSelectedJob(null)}
className="text-2xl text-gray-500 hover:text-red-500"
>
✕
</button>

</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">

<Detail label="Job Title" value={selectedJob.job_title} />

<Detail label="Company" value={selectedJob.company_name} />

<Detail label="Location" value={selectedJob.location} />

<Detail label="Job Type" value={selectedJob.job_type} />

<Detail label="Experience" value={selectedJob.experience} />

<Detail label="Salary" value={selectedJob.salary} />

<Detail label="Status" value={selectedJob.status} />

<div className="md:col-span-2">

<Detail
label="Description"
value={selectedJob.description}
/>

</div>

</div>

<div className="flex justify-end mt-8">

<button
onClick={() => setSelectedJob(null)}
className="px-5 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
>
Close
</button>

</div>

</div>

</div>

)}

                </div>

            )}

            <div
                className="modal fade"
                id="applicantsModal"
                tabIndex="-1"
                aria-hidden="true"
            >

                {selectedApplicants.length > 0 && (

<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

<div className="bg-white rounded-3xl shadow-2xl w-full max-w-6xl p-8">

<div className="flex justify-between items-center mb-6">

<h2 className="text-2xl font-bold">
Job Applicants
</h2>

<button
onClick={() => setSelectedApplicants([])}
className="text-2xl hover:text-red-500"
>
✕
</button>

</div>

<DataTable

title="Applicants"

columns={[
{ key: "id", label: "ID" },
{ key: "name", label: "Name" },
{ key: "email", label: "Email" },
{ key: "phone", label: "Phone" },
{ key: "qualification", label: "Qualification" },
{ key: "experience", label: "Experience" },
{ key: "application_status", label: "Status" },
]}

data={selectedApplicants}

/>

</div>

</div>

)}

            </div>
                    </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800 whitespace-pre-wrap">
            {value || "-"}
        </p>
    </div>
);

export default Jobs;